// extracted by mini-css-extract-plugin
export default {"EmptyScreen":"EmptyScreen__EmptyScreen___TP93Z","title":"EmptyScreen__title___HuaSu","description":"EmptyScreen__description___TAbJ7","image":"EmptyScreen__image___V3xwq"};